export const environment = {
  production: true,
  BASE_DOMAIN:'https://clpl.apollosupplychain.com/',
  New_BASE_DOMAIN:'https://clpl.apollosupplychain.com/',
  COOKIE_DOMAIN: 'localhost',
  ORDER_URL: 'https://clpl.apollosupplychain.com/',
  WebsocketUrl: 'wss://clpl.apollosupplychain.com/websocket-service/ws/notifications'
};
